module.exports = __webpack_public_path__ + "static/media/reports.7a74733b.svg";